import {
  getMobilePrefixesOptions,
  getTermsOptions,
  getProvinceOptions,
  getStoresOptions,
} from "~/composables/register-data";

import { useI18n } from "vue-i18n";

export const useRegisterOptionsStore = defineStore(
  "registerOptionsStore",
  () => {
    const { locale } = useI18n();

    const mobileOptions = ref(null) as any;
    const termsOptions = ref(null) as any;
    const provinceOptions = ref(null) as any;
    const storesOptions = ref(null) as any;
    const lastLocale = ref(locale.value);

    // Generalized fetch function for all options
    async function loadOptions(
      optionRef: Ref<any>,
      fetchFunction: () => Promise<any>
    ) {
      if (!optionRef.value || lastLocale.value !== locale.value) {
        optionRef.value = await fetchFunction();
        lastLocale.value = locale.value;
      }
    }

    async function getTerms() {
      await loadOptions(termsOptions, getTermsOptions);
    }

    async function getMobile() {
      await loadOptions(mobileOptions, getMobilePrefixesOptions);
    }

    async function getProvince() {
      await loadOptions(provinceOptions, getProvinceOptions);
    }

    async function getStores() {
      await loadOptions(storesOptions, getStoresOptions);
    }

    // Watch the locale and reset options if it changes
    watch(locale, () => {
      mobileOptions.value = null;
      termsOptions.value = null;
      provinceOptions.value = null;
      storesOptions.value = null;
    });

    return {
      getTerms,
      getMobile,
      getProvince,
      getStores,
      mobileOptions,
      termsOptions,
      provinceOptions,
      storesOptions,
    };
  }
);
